export default "/images/item_qty.png?d374fbbf5c1fb7ae57d156c8c45e4ba9";